import { render, staticRenderFns } from "./ClientsAdd.vue?vue&type=template&id=3d2d5876&"
import script from "./ClientsAdd.vue?vue&type=script&lang=js&"
export * from "./ClientsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports